import React from 'react';

import { Box, HStack, Text, VStack } from '@chakra-ui/react';

import { Button } from '@/components/core/Button';

export interface ExternalLinkContentProps {
  url: string;
  onAccept: () => void;
  onCancel: () => void;
}

export const ExternalLinkContent: React.FC<ExternalLinkContentProps> = ({
  url,
  onAccept,
  onCancel,
}) => {
  return (
    <VStack gap={{ base: 6, lg: 8 }} align='flex-start' p={{ base: 6, lg: 8 }}>
      <VStack gap={2} align='flex-start' width='100%'>
        <Text size='headingPrimary'>Leaving the application</Text>
        <Text size='primaryRegular' opacity={0.6}>
          You are about to open an external link. This website is not managed or
          controlled by us.
        </Text>
        <Box width='100%' py={2} px={3} rounded='lg' bg='search-input.bg'>
          <Text size='primaryRegular' noOfLines={3} wordBreak='break-all'>
            {url}
          </Text>
        </Box>
      </VStack>

      <HStack width='100%' justify='flex-start' gap={3}>
        <Button onClick={onAccept}>Continue</Button>
        <Button variant='glassy' onClick={onCancel}>
          Cancel
        </Button>
      </HStack>
    </VStack>
  );
};
